export default "__VITE_ASSET__1IBCKkSJ__"